export enum ActionsEnum {
  CHANGE_OBJECT = "CHANGE_OBJECT",
  CHANGE_MATERIAL = "CHANGE_MATERIAL",
  CHANGE_TEXTURE = "CHANGE_TEXTURE",
  CHANGE_COLOR = "CHANGE_COLOR",
  CHANGE_POV = "CHANGE_POV",
  CHANGE_VIEW_ALLOWED = "CHANGE_VIEW_ALLOWED",
  HIDE_UI = "HIDE_UI",
  SCREENSHOT = "SCREENSHOT",
  DEBUG_LAYER = "DEBUG_LAYER",
  CHANGE_ENVIRONMENT = "CHANGE_ENVIRONMENT",
  OTHER = "OTHER",
  NONE = "NONE",
  RUN_ANIMATIONS = "RUN_ANIMATIONS",
  HIDE_MESH = "HIDE_MESH"
}
